import { Card, Divider, Stack, TextField, Typography ,Button } from '@mui/material';
import React, { useEffect, useState } from 'react';
import {  Checkbox, DatePicker, Result } from 'antd';
import { useSearchParams } from 'react-router-dom';
import { AppColors } from '../../../Utils/helper/AppColors';
import { FiCalendar } from 'react-icons/fi';
import moment from 'moment';
import { MdAccessTime } from 'react-icons/md';
import CultService from '../../../Services/CultService';
import toast from 'react-hot-toast';
import { HelperTexts } from '../../../Utils/helper/HelperTexts';
import LabelledInput from '../../../Components/LabelledInput';
import dayjs from 'dayjs';
import PageLoader from '../../../Components/PageLoader';
import CountryCode from '../../Employees/Components/CountryCode';
import DeleteConfirm from '../../../Components/DeleteConfirm';

export default function MoodMarble() {
	const [loading, setLoading] = useState(false);
	const [fetching, setFetching] = useState(false);
	const [params] = useSearchParams();
	const [payload, setPayload] = useState({
		startTime: null,
		startDate: null,
	});


	const [details, setDetails] = useState({});
	const [userDetails, setUserDetails] = useState(null);
	const [phoneNumber, setPhoneNumber] = useState(null);

	const [startTime, setStartTime] = useState(null);
	const [endTime, setEndTime] = useState(null);

	const [success, setSuccess] = useState(false);
	const [error, setError] = useState(false);
	const [consent, setConsent] = useState(false);
	const [isNumberAlredyPresent, setIsNumberAlredyPresent] = useState(false);
	const [countryCode, setCountryCode] = useState('');

	const [userName, setUseName] = useState('');

	const [saveConfimation, setSaveConfirm] = useState(false);


	const getDetails = async () => {
		setFetching(true);
		try {
			let res = await CultService.getCampaignUserDetails({ params: { id: params.get('id') } });
			if (res.status == 200) {
				setError(res?.data?.data?.expired);
				setDetails(res.data?.data?.compaignId);
				setUserDetails(res.data?.data?.userId);
				setPhoneNumber(res.data?.data?.userId?.phoneNumber);
				setIsNumberAlredyPresent(res.data?.data?.userId?.phoneNumber ? true : false);
				setStartTime(dayjs(res.data?.data?.compaignId?.scheduling?.startTime, 'HH:mm'));
				setEndTime(dayjs(res.data?.data?.compaignId?.scheduling?.endTime, 'HH:mm'));
				setUseName(
					res.data?.data?.userId?.firstName
						? res.data?.data?.userId?.firstName + ' ' + (res.data?.data?.userId?.lastName ? res.data?.data?.userId?.lastName : '')
						: '',
				);
			}
		} catch (err) {
			toast.error(HelperTexts.SOMETHING_WENT_WRONG);
		} finally {
			setFetching(false);
		}
	};

	const handleSubmit = async (e) => {
		// e.preventDefault();
		setLoading(true);
		try {
			if (!userDetails?.phoneNumber) {
				await CultService.updatePhoneNumber({
					params: { userId: userDetails?._id },
					data: { phoneNumber: countryCode?.dial_code + phoneNumber },
				});
			}
			let res = await CultService.scheduleCampaign({ params: { id: params.get('id') }, data: payload });
			if (res?.data?.status) {
				setSuccess(true);
			} else {
				toast.error(res?.data?.message);
			}
		
		} catch (err) {
			toast.error(HelperTexts.SOMETHING_WENT_WRONG);
		} finally {
			setSaveConfirm(false);
			setLoading(false);
		}
	};

	const handleDateRange = (e) => {
		let startDate;
		if(e !== null){
		 startDate = moment(new Date(e)).format(moment.HTML5_FMT.DATE);
		}
		else{
			startDate = null;
		}
		setPayload({
			...payload,
			startDate,
		});
	};

	const handleInputChange = (key, value) => {

		if(value !== null){
			setPayload({
				...payload,
				[key]: value,
			});
		}
		else{
			setPayload({
				...payload,
				[key]: null,
			});
		}
	};

	useEffect(() => {
		if (params.get('id')) {
			getDetails();
		}
	}, [params.get('id')]);

	// const disabledHours = () => {
	// 	if (!startTime || !endTime) return [];
	// 	const hours = [];
	// 	for (let i = 0; i < 24; i++) {
	// 		if (i < startTime.hour() || i > endTime.hour()) {
	// 			hours.push(i);
	// 		}
	// 	}
	// 	return hours;
	// };

	// const disabledMinutes = (selectedHour) => {
	// 	const minutes = [];
	// 	if (!startTime || !endTime) return minutes;

	// 	if (selectedHour === startTime.hour()) {
	// 		for (let i = 0; i < startTime.minute(); i++) {
	// 			minutes.push(i);
	// 		}
	// 	}

	// 	if (selectedHour === endTime.hour()) {
	// 		for (let i = endTime.minute() + 1; i < 60; i++) {
	// 			minutes.push(i);
	// 		}
	// 	}

	// 	return minutes;
	// };



// 	const disabledHours = () => {
// 	if (!startTime || !endTime || !payload.startDate) return [];

// 	const selectedDate = moment(payload.startDate, 'YYYY-MM-DD');
// 	const startDate = moment(details?.scheduling?.startDate, 'YYYY-MM-DD');
// 	const endDate = moment(details?.scheduling?.endDate, 'YYYY-MM-DD');
// 	const today = moment();

// 	const hours = [];

// 	if (selectedDate.isSame(today, 'day')) {
// 		for (let i = 0; i < today.hour(); i++) {
// 			hours.push(i);
// 		}
// 	}

// 	if (selectedDate.isSame(startDate, 'day')) {
// 		for (let i = 0; i < startTime.hour(); i++) {
// 			if (!hours.includes(i)) hours.push(i);
// 		}
// 	}

// 	if (selectedDate.isSame(endDate, 'day')) {
// 		for (let i = endTime.hour() + 1; i < 24; i++) {
// 			if (!hours.includes(i)) hours.push(i);
// 		}
// 	}

// 	return [...new Set(hours)].sort((a, b) => a - b);
// };

// const disabledMinutes = (selectedHour) => {
// 	if (!startTime || !endTime || !payload.startDate) return [];

// 	const selectedDate = moment(payload.startDate, 'YYYY-MM-DD');
// 	const startDate = moment(details?.scheduling?.startDate, 'YYYY-MM-DD');
// 	const endDate = moment(details?.scheduling?.endDate, 'YYYY-MM-DD');
// 	const today = moment();

// 	const minutes = [];

// 	if (selectedDate.isSame(today, 'day') && selectedHour === today.hour()) {
// 		for (let i = 0; i < today.minute(); i++) {
// 			minutes.push(i);
// 		}
// 	}

// 	if (selectedDate.isSame(startDate, 'day') && selectedHour === startTime.hour()) {
// 		for (let i = 0; i < startTime.minute(); i++) {
// 			if (!minutes.includes(i)) minutes.push(i);
// 		}
// 	}

// 	if (selectedDate.isSame(endDate, 'day') && selectedHour === endTime.hour()) {
// 		for (let i = endTime.minute() + 1; i < 60; i++) {
// 			if (!minutes.includes(i)) minutes.push(i);
// 		}
// 	}

// 	return [...new Set(minutes)].sort((a, b) => a - b);
// };

const disabledHours = () => {
	if (!startTime || !endTime) return [];
  

    const selectedDate = moment(payload.startDate, 'YYYY-MM-DD');
    const today = moment();
    const startHour = startTime.hour();
    const endHour = endTime.hour();
    const currentHour = today.hour();
    const isOvernight = startHour > endHour;
    const disabled = [];
  
 // 1. If today is selected
    if (selectedDate.isSame(today, 'day')) {
        for (let i = 0; i < 24; i++) {
            if (isOvernight) {
                // startHour..23 and 0..endHour
                const inRange = (i >= startHour || i <= endHour);
                // chek if not in range and i < currentHour will work for both startHour..23 and 0..endHour 
                if (i < currentHour || !inRange) disabled.push(i);
            } else {
                //startHour..endHour
                const inRange = (i >= startHour && i <= endHour);
                
                if (i < currentHour || !inRange) disabled.push(i);
            }
        }
    } else {
        //  For other dates, just disable hours not in valid range
        for (let i = 0; i < 24; i++) {
            if (isOvernight) {
                if (!(i >= startHour || i <= endHour)) disabled.push(i);
            } else {
                if (i < startHour || i > endHour) disabled.push(i);
            }
        }
    }

	// last date check 
	if(isOvernight && details?.scheduling?.endDate === selectedDate.format('YYYY-MM-DD')) {
		for(let i = 0; i <= endHour; i++) {
			disabled.push(i);
		}
	}

	console.log('disabled--', disabled);
	return disabled;
  };
  
  const disabledMinutes = (selectedHour) => {
	if (!startTime || !endTime) return [];
  
	const selectedDate = moment(payload.startDate, 'YYYY-MM-DD');
	const today = moment();
	const startHour = startTime.hour();
	const endHour = endTime.hour();
	const startMinute = startTime.minute();
	const endMinute = endTime.minute();
	const currentMinute = dayjs().minute();
	// const currentMinute = 20;
	const isOvernight = startHour > endHour;
	const minutes = [];

	if (selectedDate.isSame(today, 'day') && selectedHour === today.hour()) {
        for (let i = 0; i < currentMinute; i++) {
            minutes.push(i);
        }
    }

    if (isOvernight) {
        if (selectedHour === startHour) {
            for (let i = 0; i < startMinute; i++) minutes.push(i);
        }
        if (selectedHour === endHour) {
            for (let i = endMinute + 1; i < 60; i++) minutes.push(i);
        }
    } else {
        if (selectedHour === startHour) {
            for (let i = 0; i < startMinute; i++) minutes.push(i);
        }
        if (selectedHour === endHour) {
            for (let i = endMinute + 1; i < 60; i++) minutes.push(i);
        }
    }

    return [...new Set(minutes)].sort((a, b) => a - b);
  };
  

	

	const isDissabled = () => {
		if (isNumberAlredyPresent) {
			return !consent || !payload?.startTime || !payload?.startDate;
		}
		return !consent || !phoneNumber || !countryCode || !payload?.startTime || !payload?.startDate;
	};


		
	return (
		<Stack
			sx={{ background: 'linear-gradient(to bottom, #f9a634, #ffe1bc)' }}
			alignItems="center"
			justifyContent="center"
			width="100vw"
			height="100vh"
			bgcolor="red"
		>
			{fetching && <PageLoader />}
			<Card sx={{ width: { xs: '90vw', md: 600 } }}>
				<Stack gap={2} width="100%">
					<Typography
						fontFamily="Quicksand"
						variant="h4"
						fontWeight={700}
						color={AppColors.TEXT_PRIMARY}
						sx={{
							display: 'flex',
							alignItems: 'center',
							gap: '10px',
							flexWrap: 'wrap',
							fontSize: { xs: '1.5rem', sm: '2rem', md: '2.5rem' }, 
						}}
					>
						Addie -
						<Typography
							variant="body1"
							fontSize={{ xs: 16, sm: 18, md: 20 }} 
							fontWeight={500}
						>
							Schedule your call with Addie
						</Typography>
					</Typography>

					<Divider />

					{success && (
						<Result
							status="success"
							title="Call scheduled Successfully"
							subTitle={`Your call for the campaign - ${details?.basicDetails?.name || 'NA'} has been scheduled.`}
						/>
					)}

					{error && <Result status="error" title="Link Expired" subTitle="This link has been expired" />}

					{!success && !error && (
						<>
							<Typography variant="caption" fontSize={14} fontWeight={400}>
								Campaign - <span style={{ fontWeight: 500 }}>{details?.basicDetails?.name || 'NA'}</span>
							</Typography>

							{userName ? (
								<Typography variant="caption" fontSize={14} fontWeight={400}>
									User Name - <span style={{ fontWeight: 500 }}>{userName || 'NA'}</span>
								</Typography>
							) : (
								''
							)}

							<Divider />

							<Stack width="fit-content">
								<LabelledInput label="Phone Number">
									<TextField
										disabled={userDetails?.phoneNumber}
										focused={!phoneNumber}
										onChange={(e) => setPhoneNumber(e.target.value)}
										value={phoneNumber}
										size="small"
										InputProps={{
											startAdornment: !userDetails?.phoneNumber ? (
												<CountryCode countryCode={countryCode} setCountryCode={setCountryCode} isNeeded={!countryCode && !userDetails?.phoneNumber && phoneNumber?.length > 9} />
											) : null,
										}}
									/>
								</LabelledInput>
							</Stack>
							{!countryCode && !userDetails?.phoneNumber && phoneNumber?.length > 9 && (
								<div style={{ fontSize: '11px', color: 'red', marginTop: '-5px' }}>Please select country code</div>
							)}
							<Divider />

							<Stack direction={{ xs: 'column', sm: 'row' }} gap={4}>
								<LabelledInput label="Select Date">
									<DatePicker
										minDate={dayjs(
											moment(details?.scheduling?.startDate, 'YYYY-MM-DD')?.isAfter(moment().format())
												? details?.scheduling?.startDate
												: moment().format(),
										)}
										maxDate={dayjs(details?.scheduling?.endDate)}
										format="MM-DD-YYYY"
										onChange={handleDateRange}
										getPopupContainer={(node) => node.parentNode}
										suffixIcon={<FiCalendar color="#667085" size={18} />}
									/>
								</LabelledInput>

								<LabelledInput label="Select Time">
									<DatePicker
									    disabled={!payload?.startDate}
										needConfirm={false}
										minuteStep={15}
										showSecond={false}
										showNow={false}
										disabledHours={disabledHours}
										disabledMinutes={disabledMinutes}
										onChange={(e) => {handleInputChange('startTime', e !== null ? moment(new Date(e)).format('HH:mm'): null) }}
										suffixIcon={<MdAccessTime color="#667085" size={18} />}
										getPopupContainer={(node) => node.parentNode}
										picker="time"
										use12Hours
									/>
								</LabelledInput>
							</Stack>

							<Divider />

							<Stack direction="row" alignItems="center" gap={1.5}>
								<Checkbox checked={consent} onChange={() => setConsent(!consent)} size="small" />
								<Typography variant="subtitle2">
									I consent to using my phone number to contact me for this conversation
								</Typography>
							</Stack>
							<Button
								disabled={isDissabled() || loading}
								variant="contained"
								color='info'
								// style={{ marginLeft: 'auto' , backgroundColor: colorSettings.buttonBackground , color: AppColors.WHITE }}
								
								
								onClick={() => setSaveConfirm(true)}
							>
								Submit
							</Button>
						</>
					)}
				</Stack>
			</Card>
			<DeleteConfirm
				loading={loading}
				open={saveConfimation}
				onDelete={() => handleSubmit()}
				onClose={() => setSaveConfirm(false)}
				title="Save Confirmation?"
				subTitle={
					<>
					  Are you sure you want to save with{' '}
					  <strong>{isNumberAlredyPresent ? phoneNumber : countryCode?.dial_code + phoneNumber}</strong>?
					</>
				  }
							  />
		</Stack>
	);
}